import { createFileRoute } from '@tanstack/react-router';

import { UpCycleRoute } from './-upCycle/UpCycleRoute.tsx';

export const Route = createFileRoute('/(app)/upCycle')({
  component: UpCycleRoute,
});
